import React from 'react';

const CreditsReminders = () => {
  return <h1>CreditsReminders Page</h1>;
};

export default CreditsReminders;
